import React from 'react';
import { ABLE_COLORS } from '../constants';
import MabelLogo from './MabelLogo';

export default function SplashScreen({ onClose }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: `radial-gradient(ellipse at top left, ${ABLE_COLORS.bg} 0%, ${ABLE_COLORS.bgSubtle} 100%)`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px 16px',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: ABLE_COLORS.cardRadiusLarge,
        padding: '60px 50px',
        maxWidth: '540px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: '56px',
          fontWeight: '700',
          color: ABLE_COLORS.primary,
          margin: '0 0 20px 0',
          letterSpacing: '-1px'
        }}>Mabel</h1>

        <div style={{ margin: '0 0 32px 0', display: 'flex', justifyContent: 'center' }}>
          <MabelLogo size={70} color={ABLE_COLORS.primary} />
        </div>

        <h2 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: ABLE_COLORS.textPrimary,
          lineHeight: 1.3,
          margin: '0 0 24px 0'
        }}>
          Stop forcing. Start flowing.
        </h2>

        <p style={{
          fontSize: '18px',
          color: ABLE_COLORS.textSecondary,
          lineHeight: 1.5,
          margin: '0 0 32px 0',
          fontWeight: '500'
        }}>
          An adaptive planner that moves with your mood.
        </p>

        <div style={{
          fontSize: '15px',
          color: ABLE_COLORS.textMuted,
          marginBottom: '48px',
          lineHeight: 1.6
        }}>
          For overwhelming days...<br/>
          <span style={{ fontStyle: 'italic' }}>...and unstoppable ones.</span>
        </div>

        <button
          onClick={onClose}
          style={{
            background: `linear-gradient(135deg, ${ABLE_COLORS.warm} 0%, ${ABLE_COLORS.accent} 100%)`,
            color: 'white',
            border: 'none',
            padding: '18px 60px',
            borderRadius: ABLE_COLORS.buttonRadius,
            fontSize: '18px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            width: '100%',
            maxWidth: '320px',
            boxShadow: `0 8px 24px ${ABLE_COLORS.warm}66`
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = `0 12px 32px ${ABLE_COLORS.warm}88, 0 0 20px ${ABLE_COLORS.warm}66`;
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = `0 8px 24px ${ABLE_COLORS.warm}66`;
          }}
        >
          Let's flow →
        </button>
      </div>
    </div>
  );
}
